import { colors as themeColors } from '../utils/theme';
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { Box, Grid, Paper, Typography, TextField, Button, Autocomplete, Dialog, DialogContent, Divider, CircularProgress, LinearProgress, Tooltip, IconButton, Snackbar, useTheme, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, DialogTitle, DialogActions, CardContent, Card, Checkbox, Avatar, Collapse } from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import MuiAlert from "@mui/material/Alert";
import ClientMaster from "./ClientMaster";
import CitySearchInput from "../components/CitySearchInput";
import CityPopupModal from "../components/CityPopupModal";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { toProperCase } from "../utils/formatRows";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
import { useMediaQuery } from "@mui/system";
import NoDataComponent from "../components/NoDataComponent";
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { gradients } from '../utils/theme';

function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

export default function ConsigneeMaster({ onSaved, mode, connectionString, onPopupCancel, clientId, clientFirmName, onBack, activeViewHandler }) {

    const { user, selectedCompany, loading } = useAuth();
    const role = user?.UserCategory;
    const theme = useTheme();
    const API = connectionString;
    const companyId = selectedCompany?.CompId;
    const userId = user?.UserId;
    const wrapperRef = useRef(null);

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [showForm, setShowForm] = useState(true);
    const [showGrid, setShowGrid] = useState(true);

    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [selectAll, setSelectAll] = useState(false);

    const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

    const [localMode, setLocalMode] = useState(mode);
    const [form, setForm] = useState({ ConName: "", Address: "", City: "", Pincode: "", Distance: "", State: "", Statecode: "", GSTNO: "", PANNo: "", ContactPerson: "", Mobile: "", Email: "" });
    const [errors, setErrors] = useState({});
    const validators = { GSTNO: v => v === "" || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(v),
        PANNo: v => v === "" || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v),
        Mobile: v => v === "" || /^\d{10}$/.test(v),
        Email: v => v === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        Pincode: v => v === "" || /^\d{1,6}$/.test(v),
    };

    const [editId, setEditId] = useState(null);

    const [partyName, setPartyName] = useState("");
    const [partyID, setPartyID] = useState(null);
    const [selectedParty, setSelectedParty] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [suggestions, setSuggestions] = useState([]);

    const [cityQuery, setCityQuery] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [cityError, setCityError] = useState("");
    const [cityResults, setCityResults] = useState([]);
    const [showCityModal, setShowCityModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loadingGrid, setLoadingGrid] = useState(false);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [totalCount, setTotalCount] = useState(0);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    console.log("selectionModel", selectionModel)

    const [accountOptions, setAccountOptions] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const cityInputRef = useRef(null);
    const [showClientModal, setShowClientModal] = useState(false);
    const EMAIL_SUGGESTIONS = [ 'nomail@gmail.com', ];
    const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);
    const [companyName, setCompanyName] = useState("")

    // ============ GST VERIFICATION STATE ============
    const [gstVerifyNo, setGstVerifyNo] = useState("");
    const [gstVerifyError, setGstVerifyError] = useState("");
    const [gstVerifyValid, setGstVerifyValid] = useState(null);
    const [gstVerifyLoading, setGstVerifyLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    // const { clientId, clientFirmName, partyId } = location.state || {};
    const { conId, partyId } = useParams();

    const requiredLabelSX = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    const filteredMobileRows = useMemo(() => {
        if (!isSmallScreen) return rows;
        if (!mobileSearchQuery.trim()) return rows;

        const q = mobileSearchQuery.toLowerCase();

        return rows.filter((row) => {
            const name = row.ConName?.toLowerCase() || '';

            return (
                name.startsWith(q) ||                         // 🔥 primary (exact-like)
                // row.City?.toLowerCase().includes(q) ||
                // row.State?.toLowerCase().includes(q) ||
                row.GSTNO?.toLowerCase().includes(q) ||
                // row.Mobile?.toLowerCase().includes(q) ||
                row.ContactPerson?.toLowerCase().includes(q)
            );
        });
    }, [rows, mobileSearchQuery, isSmallScreen]);

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            setSelectAll(false);
        } else {
            const allIds = filteredMobileRows.map(row => row.ConID);
            setSelectionModel(allIds);
            setSelectAll(true);
        }
    };

    useEffect(() => {
        if (!clientId) return;

        // Pre-populate with the passed client data
        setPartyID(clientId);
        setPartyName(clientFirmName || '');
        setSelectedParty({ id: clientId, FirmName: clientFirmName || '' });
    }, [clientId, clientFirmName]);

    useEffect(() => {
        if (!partyId) return;

        const pid = Number(partyId);
        setPartyID(pid);

        (async () => {
            try {
                console.log(pid)
                const party = await fetchPartyById(pid);
                if (party) {
                    setPartyName(party.FirmName ?? "");
                    setSelectedParty({ id: party.id ?? party.PartyID ?? pid, FirmName: party.FirmName ?? "" });
                }
            } catch (err) {
                console.warn("Could not fetch party info:", err);
            }
        })();
    }, [partyId]);

    useEffect(() => {
        if (!partyName || !dropdownOpen) {
            setSuggestions([]);
            return;
        }
        (async () => {
            const data = await fetchPartySuggestions(partyName);
            setSuggestions(data);
        })();
    }, [partyName, dropdownOpen]);

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', companyId: companyId } });
                const accountData = transform(res.data.data || [], 'id', 'FirmName');
                setAccountOptions(accountData);
                if (form.accountId) {
                    const found = accountData.find(opt => String(opt.id) === String(form.accountId));
                    setSelectedAccount(found || null);
                } else {
                    setSelectedAccount(null);
                }
            } catch (err) {
                console.error('Error fetching accounts:', err);
                setAccountOptions([]);
                setSelectedAccount(null);
            }
        };
        fetchAccounts();
    }, [form.accountId]);

    useEffect(() => {
        if (!cityQuery) {
            setCityResults([]);
            return;
        }
        const delayDebounce = setTimeout(async () => {
            try {
                const res = await axios.get(`${API}/api/city-search`, { params: { q: cityQuery } });
                setCityResults(res.data || []);
            } catch (err) {
                setCityResults([]);
            }
        }, 400);
        return () => clearTimeout(delayDebounce);
    }, [cityQuery]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if ( wrapperRef.current && !wrapperRef.current.contains(event.target) ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);


    const fetchGrid = useCallback(async () => {
        if (!partyID) return;
        setLoadingGrid(true);
        try {
            const resp = await axios.get(`${API}/api/consignee-getData-byPartyId`, { params: { PartyID: partyID, userId, companyId, offset: paginationModel.page * paginationModel.pageSize, limit: paginationModel.pageSize }, headers: { 'Cache-Control': 'no-store' }, validateStatus: (s) => (s >= 200 && s < 300) || s === 304 });
            const rawData = resp.data.success && Array.isArray(resp.data?.data) ? resp.data.data : [];
            const total = resp.data.success && typeof resp.data?.total === 'number' ? resp.data.total : 0;
            // REMOVE DECIMAL PART FROM DISTANCE
            const data = rawData.map(row => ({ ...row, Distance: row.Distance !== null && row.Distance !== undefined ? Math.trunc(Number(row.Distance)) : row.Distance }));
            setRows(data);
            setTotalCount(total);
            console.log(data);
        } catch (err) {
            console.error('Error fetching consignee data:', err);
            setRows([]);
            setTotalCount(0);
            setSnackbar({ open: true, message: 'Failed to fetch consignee data.', severity: 'error' });
        } finally {
            setLoadingGrid(false);
        }
    }, [partyID, userId, companyId, paginationModel, API]);

    useEffect(() => {
        if (partyID == null) return;
        fetchGrid();
    }, [partyID, fetchGrid]);

    const fetchPartySuggestions = async (query) => {
        try {
            const res = await axios.get(`${API}/api/company-search`, { params: { field: "FirmName", search: query, companyId } });
            return res.data.data || [];
        } catch {
            return [];
        }
    };

    const fetchPartyById = async (id) => {
        if (!id) return null;
        try {
            console.log(id);
            const fallback = await axios.get(`${API}/api/company-search`, { params: { field: "id", search: id, companyId: companyId } });
            const list = fallback.data?.data || [];
            console.log(list);
            return list.length ? list[0] : null;
        } catch (err) {
            console.warn("fetchPartyById failed", err);
            return null;
        }
    };

    const handlePartyChange = (_, option) => {
        if (option?.id === "add-new") {
            setShowClientModal(true);
            setDropdownOpen(false);
        } else {
            setShowClientModal(false);
            setSelectedParty(option);
            setPartyID(option?.id || null);
            setPartyName(option?.FirmName || '');
            setDropdownOpen(false);
        }
    };

    const handleBlur = (key) => () => {
        const val = form[key] ?? "";

        // 🔴 PINCODE: EXACTLY 6 digits
        if (key === "Pincode") {
            if (val && val.length !== 6) {
                setErrors(e => ({ ...e, Pincode: true }));
            } else {
                setErrors(e => ({ ...e, Pincode: false }));
            }
            return;
        }

        // ⬇️ baaki fields ka existing logic
        if (!validators[key]) return;

        if (!val) {
            setErrors(e => ({ ...e, [key]: false }));
            return;
        }

        setErrors(e => ({ ...e, [key]: !validators[key](val) }));
    };

    const properCaseFields = [ "ConName", "ContactPerson", "Address" ];

    const handleChange = key => e => {
        const { value } = e.target;
        setForm(f => ({ ...f, [key]: properCaseFields.includes(key) ? toProperCase(value) : value }));
    };

    // ============ GST AUTO FILL ============
    const handleGstAutoFill = async () => {
        if (gstVerifyNo.length !== 15) {
            setSnackbar({ open: true, message: "Please enter a valid 15-character GST No", severity: "error" });
            return;
        }

        if (!gstVerifyValid) {
            setSnackbar({ open: true, message: "Invalid GST format", severity: "error" });
            return;
        }

        try {
            setGstVerifyLoading(true);
            const gstRes = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gstVerifyNo } });
            const d = gstRes.data.data || {};

            // Fill the consignee form fields from GST data
            setForm(prev => ({
                ...prev,
                ConName: d.clientName || "",
                ContactPerson: d.contactPerson || "",
                Address: d.address || "",
                City: d.city || "",
                Pincode: d.PinCode ? String(d.PinCode) : "",
                State: d.state || "",
                Statecode: d.stateCode || gstVerifyNo.slice(0, 2),
            }));

            // ✅ Also set cityQuery to display city in the form
            if (d.city) {
                setCityQuery(d.city);
            }

            setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
        } catch (gstErr) {
            setGstVerifyValid(false);
            const errorMsg = gstErr.response?.data?.message || "Unable to fetch details for given GST No.";
            setSnackbar({ open: true, message: errorMsg, severity: "error" });
            setGstVerifyError(errorMsg);
        } finally {
            setGstVerifyLoading(false);
        }
    };

    const resetAndCancel = () => {
        setLocalMode("add");
        setEditId(null);
        setPartyID(null);
        setPartyName("");
        setSelectedParty(null);
        setSelectedAccount(null);
        setCityQuery("");
        setForm({ ConName: "", Address: "", City: "", Pincode: "", Distance: "", State: "", Statecode: "", GSTNO: "", PANNo: "", ContactPerson: "", Mobile: "", Email: "" });
        setGstVerifyNo("");
        setGstVerifyError("");
        setGstVerifyValid(null);
        setErrors({});
        setRows([]);
        setTotalCount(0);
        if (typeof onPopupCancel === "function") {
            onPopupCancel();      // ✅ close popup
        }

    };

    const validateFormBeforeSubmit = () => {
        let newErrors = {};

        // 🔴 REQUIRED
        if (!form.ConName?.trim()) newErrors.ConName = true;
        // 🟡 OPTIONAL (validate only if filled)

        if (form.Pincode && !/^\d{6}$/.test(form.Pincode)) {
            newErrors.Pincode = true;
        }

        if (form.Distance && !/^\d+$/.test(form.Distance)) {
            newErrors.Distance = true;
        }

        if (form.City && !form.City.trim()) {
            newErrors.City = true;
        }

        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            setSnackbar({ open: true, severity: "error", message: "Required fields are missing", });
            return false;
        }

        // 🟡 OPTIONAL but must be valid if filled
        for (const key of ["GSTNO", "Mobile", "PANNo", "Email"]) {
            if (form[key] && !validators[key](form[key])) {
                setErrors(e => ({ ...e, [key]: true }));
                setSnackbar({ open: true, severity: "error", message: `Invalid ${key}`, });
                return false;
            }
        }

        setErrors({});
        return true;
    };


    const FN_HandleSubmit = async () => {

        if (!validateFormBeforeSubmit()) return;

        const payload = { PartyID: partyID, ...form, companyId, userId, accountId: selectedAccount?.id || null };
        try {
            if (localMode === "add") {
                await axios.post(`${API}/api/consignee/insert`, payload);
                if (typeof onPopupCancel === "function") {
                    setSnackbar({ open: true, message: "Consignee added successfully!", severity: 'success' })
                    setTimeout(() => { onPopupCancel() }, 600)
                }
                else {
                    setSnackbar({ open: true, message: "Consignee added successfully!", severity: 'success' })
                    setTimeout(() => {
                        // navigate(-1);
                        if (activeViewHandler) {
                            activeViewHandler()
                        } else {
                            navigate(-1)
                        }
                    }, 600);
                }

            }
            else if (editId != null) {
                await axios.put(`${API}/api/consignee/update/${editId}`, payload);
                if (typeof onPopupCancel === "function") {
                    onPopupCancel()
                }
                else {
                    setSnackbar({ open: true, message: "Consignee updated successfully!", severity: 'success' })
                    setTimeout(() => {
                        // navigate(-1);
                        if (activeViewHandler) {
                            activeViewHandler()
                        } else {
                            navigate(-1)
                        }
                    }, 600);
                }
            }
            onSaved?.();
            resetAndCancel();
        } catch (error) {
            console.error('Save error:', error);
            setSnackbar({ open: true, message: "Save failed.", severity: 'error' });
        }
    };

    const handleDelete = async () => {
        if (!selectionModel.length || deleting) return;
        setDeleting(true);
        try {
            const response = await axios.post(`${API}/api/consignee/delete`, { userId, objAryId: selectionModel });
            setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });
            setSelectionModel([]);
            fetchGrid();
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({ open: true, message: data.error, severity: "warning" });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({ open: true, message: "Delete failed due to an unexpected error.", severity: "error" });
            }
        } finally {
            setDeleting(false);
            setConfirmOpen(false);
        }
    };

    const renderConsigneeCards = () => {
        if (loadingGrid) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (filteredMobileRows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CustomNoDataOverlay />
                </Box>
            );
        }


        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <CustomNoDataOverlay />
                    <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
                        Page: {paginationModel.page + 1} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {filteredMobileRows.map((row) => {
                    const isSelected = selectionModel.includes(row.ConID);
                    const avatarColor = stringToColor(row.clientFirmName || 'C');
                    const initials = getInitials(row.clientFirmName);
                    const locationText = [row.City, row.State].filter(Boolean).join(', ') || '—';

                    return (
                        <Card key={row.ConID} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, borderLeft: '4px solid', borderLeftColor: 'primary.main', cursor: 'pointer' }}
                            onClick={() => navigate( `/main/edit-consignee/${row.ConID}/${row.PartyID}`, { state: { partyId: row.PartyID } } ) }
                        >
                            <CardContent sx={{ py: 1.8, px: 2 }}>
                                {/* Header */}
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {role !== 'User' && <Checkbox size="small" checked={isSelected} onClick={(e) => e.stopPropagation()}
                                        onChange={() => setSelectionModel((prev) => isSelected ? prev.filter((id) => id !== row.ConID) : [...prev, row.ConID] ) }
                                        sx={{ mr: 1 }}
                                    />
                                    }

                                    <Avatar sx={{ bgcolor: avatarColor, color: themeColors.neutral.surface, width: 36, height: 36, fontWeight: 'bold', mr: 1.5 }} >
                                        {initials}
                                    </Avatar>

                                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: '1rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textDecoration: "underline", color: theme.palette.primary.main, cursor: "pointer" }}

                                            onClick={(e) => {
                                                e.stopPropagation(); // ✅ IMPORTANT (prevents grid re-selection)

                                                if (!row.ConID) return;
                                                setEditId(row.ConID);
                                                setLocalMode("edit");
                                                setForm({ ConName: row?.ConName || "", Address: row?.Address || "", City: row?.City || "", Pincode: row?.Pincode || "", Distance: row?.Distance || "", State: row?.State || "", Statecode: row?.Statecode || "", GSTNO: row?.GSTNO || "", PANNo: row?.PANNo || "", ContactPerson: row?.ContactPerson || "", Mobile: row?.Mobile || "", Email: row?.Email || "" });
                                                setGstVerifyNo(row?.GSTNO || "");
                                                // ✅ ONLY update display fields (NO partyID change)
                                                setPartyName(prev => prev);
                                                setSelectedParty(prev => prev);
                                                setCityQuery(row?.City || "");
                                            }}
                                        >
                                            {row.ConName || '—'}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                            {locationText}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Body */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PersonIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.ContactPerson || '—'}
                                            </Typography>
                                        </Box>

                                    </Box>
                                    <Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'primary.main' }} >
                                                {row.Mobile || '—'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <ReceiptIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                                        <Typography variant="body2" color="text.secondary">
                                            GST: {row.GSTNO || '—'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Pagination */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2 }} >
                    <Button variant="outlined" disabled={paginationModel.page === 0} onClick={() => setPaginationModel((p) => ({ ...p, page: Math.max(0, p.page - 1) })) } >
                        ← Previous
                    </Button>

                    <Typography variant="body2">
                        Page {paginationModel.page + 1} of{' '}
                        {Math.ceil(totalCount / paginationModel.pageSize) || 1}
                    </Typography>

                    <Button variant="outlined" disabled={ (paginationModel.page + 1) * paginationModel.pageSize >= totalCount } onClick={() => setPaginationModel((p) => ({ ...p, page: p.page + 1 })) } >
                        Next →
                    </Button>
                </Box>
            </>
        );
    };


    // --- SAFE COLUMNS: guard against missing params / params.row ---
    const columns = [
        { field: "ConName", headerName: "Consignee Details", flex: 1,
            renderCell: (params) => {
                const row = params?.row ?? {};
                const ConID = row?.ConID ?? params?.id;

                const name = row?.ConName ?? "—";
                const city = row?.City;
                const state = row?.State;

                const location = city || state ? [city, state].filter(Boolean).join(", ") : "—";

                return (
                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.3 }}>
                        {/* 🔹 Consignee Name */}
                        <Typography variant="body2" sx={{ fontWeight: 600, textDecoration: "underline", color: theme.palette.primary.main, cursor: "pointer", }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!ConID) return;
                                setEditId(ConID);
                                setLocalMode("edit");
                                setForm({ ConName: row?.ConName || "", Address: row?.Address || "", City: row?.City || "", Pincode: row?.Pincode || "", Distance: row?.Distance || "", State: row?.State || "", Statecode: row?.Statecode || "", GSTNO: row?.GSTNO || "", PANNo: row?.PANNo || "", ContactPerson: row?.ContactPerson || "", Mobile: row?.Mobile || "", Email: row?.Email || "", });
                                setCityQuery(row?.City || "");
                            }}
                        >
                            {name}
                        </Typography>

                        {/* 🔹 Location under name */}
                        <Typography variant="caption" sx={{ color: "text.secondary" }} >
                            {location}
                        </Typography>
                    </Box>
                );
            },
        },
        { field: "Pincode", headerName: "Pincode", flex: 0.4, },
        { field: "GSTNO", headerName: "GST No.", flex: 0.7, },
        { field: "Mobile", headerName: "Mobile No.", flex: 0.6, },
        {
            flex: 0.1, sortable: false,
            renderCell: (params) => {
                const row = params?.row ?? {};
                const id = row?.ConID ?? params?.id;
                const sel = Array.isArray(selectionModel) ? selectionModel.includes(id) : (selectionModel?.has ? selectionModel.has(id) : false);
                return (
                    <Tooltip title="Delete">
                        <span>
                            <IconButton color="error" size="small" disabled={!sel}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmOpen(true);   // 🔥 open dialog
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            }
        }
    ];

    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete fullWidth options={options} getOptionLabel={opt => opt?.label || ''} value={value} onChange={(_, v) => setValue(v)} isOptionEqualToValue={(opt, val) => opt?.id === val?.id} disabled={localMode !== "add" && localMode !== "edit"}
                renderInput={params => (
                    <TextField {...params} label={label} size="small" InputLabelProps={{ shrink: Boolean(value) }} sx={{ '& .MuiOutlinedInput-root': { height: 30, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                )}
            />
        </Grid>
    );

    return (
        <Box>
            <Paper elevation={3} sx={{ px: 3, py: 1, maxWidth: 735, mx: "auto", bgcolor: theme.palette.background.paper ,  mx: { xs: 0, sm: 3, md: "auto" }, boxShadow: { xs: onPopupCancel ? "none" : "none",  sm: onPopupCancel ? "none" : "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)" } }}  >
                <Box sx={{ position: "relative", display: "flex", alignItems: "center", mb: 1, }} >
                    {/* ⬅️ Back Button (LEFT) */}
                    {onBack && (
                        <Button variant="outlined" onClick={onBack} sx={{ position: "absolute", left: 0 }} size="small" >
                            ← Back
                        </Button>
                    )}

                    {/* 🏷️ Title (TRUE CENTER) */}
                    <Typography variant="h5" sx={{ width: "100%", textAlign: "center", fontSize: { xs: "1.25rem", sm: "1.5rem" }, fontWeight: 600, pointerEvents: "none", }} >
                        {localMode === "add" ? "Add New Consignee" : "Edit Consignee"}
                    </Typography>

                </Box>

                <Box>
                    <Box sx={{ position: "relative", mb: 1.5 }} ref={wrapperRef}>
                        <TextField fullWidth size="small" label="Company Name" placeholder="Search Company Name" required value={toProperCase(partyName)} disabled={!!clientId} onFocus={() => !clientId && setDropdownOpen(true)} InputLabelProps={{ sx: requiredLabelSX }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                            onChange={(e) => {
                                if (!clientId) {
                                    setPartyName(toProperCase(e.target.value));
                                    setDropdownOpen(true);
                                }
                            }}
                        />
                        {dropdownOpen && partyName && (
                            <Paper elevation={0} sx={{ position: "absolute", top: "100%", mt: 1, width: "100%", zIndex: 10, border: "1px solid rgba(0,0,0,0.2)", borderRadius: 1, maxHeight: 260, overflowY: "auto", backgroundColor: themeColors.neutral.surface, }} >
                                <Table size="small" stickyHeader>

                                    <TableBody>
                                        {suggestions.length > 0 ? (
                                            suggestions.map((r, i) => (
                                                <TableRow key={i} hover sx={{ cursor: "pointer" }} onMouseDown={(e) => handlePartyChange(e, r)} >
                                                    <TableCell>{r.FirmName}</TableCell>
                                                    {/* <TableCell>{r.GSTNo || "-"}</TableCell> */}
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={2} align="center" sx={{ color: "error.main" }}>
                                                    Client not found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                    {/* Sticky Add New */}
                                    <TableFooter sx={{ position: "sticky", bottom: 0, background: themeColors.neutral.surface }}>
                                        <TableRow hover
                                            onMouseDown={(e) =>
                                                handlePartyChange(e, { id: "add-new" })
                                            }
                                        >
                                            <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                ➕ Add New Client
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </Paper>
                        )}

                    </Box>


                    <Grid container spacing={isSmallScreen ? 0 : 1.5}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Grid container spacing={1.5} flexDirection="column">
                                {/* Swapped: GSTNO first, ConName in second position */}
                                <Grid item size={{ xs: 12 }}>
                                    <Grid container spacing={1} alignItems="flex-start">
                                        <Grid item xs>
                                            <TextField
                                                fullWidth
                                                label="GST No."
                                                size="small"
                                                value={gstVerifyNo}
                                                error={Boolean(gstVerifyError)}
                                                helperText={gstVerifyError || "Enter 15-digit GST number"}
                                                inputProps={{ maxLength: 15 }}
                                                onChange={(e) => {
                                                    const val = e.target.value.toUpperCase();
                                                    if (/^[0-9A-Z]*$/.test(val)) {
                                                        setGstVerifyNo(val);
                                                        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                                                        if (!val) {
                                                            setGstVerifyError("");
                                                            setGstVerifyValid(null);
                                                        } else if (!gstRegex.test(val)) {
                                                            setGstVerifyError("Invalid pattern");
                                                            setGstVerifyValid(false);
                                                        } else {
                                                            setGstVerifyError("");
                                                            setGstVerifyValid(true);
                                                        }
                                                    }
                                                }}
                                                sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                onClick={handleGstAutoFill}
                                                disabled={gstVerifyLoading || gstVerifyNo.length !== 15}
                                                sx={{ mt: 0.5 }}
                                            >
                                                {gstVerifyLoading ? <CircularProgress size={16} /> : "Verify"}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* ConName field - now in second position */}
                                <Grid item size={{ xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label="Consignee Name"
                                        size="small"
                                        required
                                        value={form.ConName ?? ""}
                                        onBlur={handleBlur("ConName")}
                                        error={Boolean(errors.ConName)}
                                        onChange={handleChange("ConName")}
                                        InputLabelProps={{ sx: requiredLabelSX }}
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}
                                    />
                                </Grid>

                                {/* Mobile and Address fields */}
                                {[["Mobile", "Mobile"], ["Address", "Address"]].map(([key, label]) => (
                                    <Grid item size={{ xs: 12 }} key={key}>
                                        <TextField fullWidth label={label} size="small" value={form[key] ?? ""} onBlur={handleBlur(key)}error={Boolean(errors[key])}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                // 🔒 Mobile: digits only
                                                if (key === "Mobile") {
                                                    value = value.replace(/\D/g, "").slice(0, 10);
                                                }
                                                handleChange(key)({ target: { value } });
                                            }}
                                            helperText={
                                                errors[key]
                                                    ? {
                                                        Mobile: "Must be 10 digits",
                                                    }[key]
                                                    : ""
                                            }
                                            InputLabelProps={{
                                                sx: requiredLabelSX,
                                            }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center', }, '& .MuiOutlinedInput-input': { padding: '0 12px', fontSize: '0.875rem', }, }}
                                            {...(key === "Address"
                                                ? { multiline: true,
                                                    sx: { '& .MuiOutlinedInput-inputMultiline': { minHeight: '80px', padding: '8px 12px', }, },
                                                } : {})}
                                        />
                                    </Grid>
                                ))}
                                <Grid item size={{ xs: 12 }}>
                                    <Box display="flex" gap={1}>
                                        <TextField fullWidth label="Pincode" size="small" value={form.Pincode} inputProps={{ maxLength: 6 }} onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ""); // 🔒 only digits
                                            setForm(f => ({ ...f, Pincode: value }));
                                        }} helperText={ errors.Pincode ? "Pincode must be 6 digits" : "" } onBlur={handleBlur("Pincode")} error={Boolean(errors.Pincode)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                        <TextField fullWidth label="Distance" size="small" value={form.Distance} onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d*$/.test(val)) {
                                                setForm(f => ({ ...f, Distance: val }));
                                            }
                                        }} onBlur={handleBlur("Distance")} error={Boolean(errors.Distance)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }} inputProps={{ maxLength: 6 }} />
                                    </Box>
                                </Grid>
                                <Box sx={{ flex: '0 0 46%' }} />
                            </Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>

                            <Grid container spacing={1.5} flexDirection="column">                            {[
                                ["ContactPerson", "Contact Person"],
                                ["PANNo", "PAN No."],
                                ["Email", "Email"],
                                // ["Mobile", "Mobile"],
                                // ["PANNo", "PAN No."]
                            ].map(([key, label]) => (
                                <Grid item xs={12} key={key}>
                                    <TextField fullWidth size="small" label={label} value={form[key]} onBlur={handleBlur(key)} error={Boolean(errors[key])}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            // 🔒 PAN: A–Z + 0–9, max 10 chars
                                            // 🔒 PAN: only A–Z & 0–9, max 10
                                            if (key === "PANNo") {
                                                value = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
                                            }
                                            // 🔒 Mobile: digits only, max 10
                                            if (key === "Mobile") {
                                                value = value.replace(/\D/g, "").slice(0, 10);
                                            }
                                            handleChange(key)({ target: { value } });
                                        }}
                                        helperText={
                                            errors[key]
                                                ? {
                                                    Email: "Invalid email",
                                                    Mobile: "Must be 10 digits",
                                                    Pincode: "Must be 6 digits",
                                                    PANNo: "Invalid PAN Number",
                                                    GSTNO: "Max 15 chars"
                                                }[key] : ""
                                        }
                                        inputProps={ key === "PANNo" ? { maxLength: 10 } : key === "Mobile" ? { inputMode: "numeric", pattern: "[0-9]*", maxLength: 10, } : {} }
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    />
                                </Grid>
                            ))}
                                <Grid item size={{ xs: 12 }}>
                                    <CitySearchInput value={selectedCity?.city || cityQuery} error={Boolean(errors.City)} cities={cityResults} connectionString={connectionString}
                                        onChangeQuery={(q) => {
                                            setCityQuery(q);
                                            if (cityError) setCityError("");
                                        }}
                                        onSelectCity={(c) => {
                                            setSelectedCity(c);
                                            setForm(f => ({ ...f, City: c.city, State: c.state, Statecode: c.stateCode }));
                                            setCityQuery("");
                                            setCityError("");
                                        }}
                                    />
                                    {cityError && (<Typography variant="caption" color="error">{cityError}</Typography>)}
                                </Grid>
                                <Grid item size={{ xs: 12 }}>
                                    <Box display="flex" gap={1}>
                                        <TextField label="State" size="small" value={form.State} disabled fullWidth sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                        <TextField label="State Code" size="small" value={form.Statecode} disabled sx={{ width: 120, '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="center" gap={1.5} sx={{mt:isSmallScreen ? 1.5 : 0}}>
                        <Button variant="contained" color="primary" size="small" sx={{ px: 2 }} onClick={FN_HandleSubmit} > {localMode === "add" ? "Submit" : "Update"} </Button>
                        <Button variant="contained" color="error" size="small" sx={{ px: 2 }} onClick={() => {
                            if (typeof onPopupCancel === "function") {
                                resetAndCancel();
                            } else {
                                if (activeViewHandler) {
                                    activeViewHandler()
                                } else {
                                    navigate(-1)
                                }
                            }
                        }} > Cancel </Button>
                    </Box>
                </Box>
                <Box mt={1.5} sx={{ minHeight: 200 }}>
                    {loadingGrid && <CircularProgress />}
                    {!loadingGrid && rows.length === 0 ? (
                        <Typography sx={{ textAlign: "center", width: "100%" }}>No Consignee Found</Typography>
                    ) : (isSmallScreen ? (
                        <>
                            <Box sx={{ mb: 1, px: 1 }}>
                                <TextField fullWidth size="small" placeholder="Search consignees..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                            {role !== 'User' && selectionModel.length > 0 && (
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                        <Typography variant="body2" sx={{ ml: 1 }}> {selectionModel.length} selected </Typography>
                                    </Box>
                                    <Tooltip title="Delete selected">
                                        <IconButton
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setConfirmOpen(true);
                                            }} color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            )}
                            <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
                                {renderConsigneeCards()}
                            </Box>
                        </>
                    ) : (
                        // autoHeight
                        <DataGrid rows={rows} columns={columns} getRowId={r => r.ConID} checkboxSelection rowSelectionModel={selectionModel} onRowSelectionModelChange={(newSelection) => { setSelectionModel(newSelection); }} columnHeaderHeight={38} rowHeight={43} getRowHeight={() => 'auto'} disableRowSelectionOnClickloading={loadingGrid} pagination paginationMode="server"
                            slots={{ noResultsOverlay: CustomNoDataOverlay }}
                            slotProps={{
                                noResultsOverlay: {
                                    width: 110,
                                    mb: 1,
                                    fontSize: "12px"
                                },
                            }}

                            rowCount={totalCount}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[25, 50, 100]}
                            sx={{
                                '& .MuiDataGrid-columnHeaders': { backgroundColor: themeColors.neutral.gridHeader, borderBottom: `1px solid ${themeColors.neutral.border}` },
                                '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 500 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
                                // Background styling
                                '& .MuiDataGrid-filler': { backgroundColor: themeColors.neutral.surface },
                                '& .MuiDataGrid-scrollbarFiller': { backgroundColor: themeColors.neutral.gridHeader },
                                // Row styling
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                '& .MuiDataGrid-row:hover': { backgroundColor: themeColors.primary.tint },
                                // Selected row styling (with !important to override default MUI)
                                '& .MuiDataGrid-row.Mui-selected': { backgroundColor: `${themeColors.primary.selected} !important` },
                                // Cell content alignment
                                '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center', whiteSpace: 'normal', wordBreak: 'break-word', },
                                '& .MuiDataGrid-footerContainer': { minHeight: 32, height: 32, },
                                minHeight: "200px",
                                height: "200px",
                            }}
                        />
                    )
                    )}
                </Box>

                <Dialog fullWidth maxWidth="md" open={showClientModal} onClose={(event, reason) => { if (reason === 'backdropClick') return; setShowClientModal(false); }} >
                    <DialogContent>
                        <ClientMaster mode="add" onPopupCancel={() => setShowClientModal(false)} connectionString={connectionString}
                            onSaved={newClient => {
                                setShowClientModal(false);
                                fetchPartySuggestions();
                            }}
                        />
                    </DialogContent>
                </Dialog>

                {showCityModal && (
                    <CityPopupModal onClose={() => setShowCityModal(false)}
                        onCityAdded={c => {
                            setForm(f => ({ ...f, City: c.city, State: c.state, Statecode: c.stateCode }));
                            setCityQuery(c.city);
                            setShowCityModal(false);
                        }}
                    />
                )}
                <Snackbar open={snackbar.open} autoHideDuration={9000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                    <MuiAlert elevation={6} variant="filled" severity={snackbar.severity} sx={{ width: "100%" }} onClose={() => setSnackbar(s => ({ ...s, open: false }))} >
                        {snackbar.message}
                    </MuiAlert>
                </Snackbar>

                <Dialog
                    open={confirmOpen}
                    onClose={() => { if (!deleting) setConfirmOpen(false); }}
                    maxWidth="xs"
                    fullWidth
                >
                    {deleting
                        ? <LinearProgress color="error" sx={{ height: 4 }} />
                        : <Box sx={{ height: 4, background: gradients.danger }} />}
                    <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                        <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                            Confirm Deletion
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ px: 2.5, py: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Are you sure you want to delete{' '}
                            <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                                {Array.isArray(selectionModel)
                                    ? selectionModel.length
                                    : selectionModel?.size || 0}
                            </Typography>
                            {' '}consignee record(s)? This action cannot be undone.
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                        <Button color="error" variant="contained" size="small" disabled={deleting}
                            startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                            onClick={() => handleDelete()}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                    </Box>
                </Dialog>

            </Paper>
        </Box>
    );
}